import { Box, styledComponent, Typography } from '@hermes/web-components'

export const BodyContainer = styledComponent(Box, {
  shouldForwardProp: (prop) => prop !== 'disablePadding'
})<{ disablePadding?: boolean }>(({ theme, disablePadding = false }) => ({
  maxWidth: '670px',
  width: '100%',
  margin: '0 auto',
  [theme.breakpoints.down('sm')]: {
    padding: disablePadding ? '0' : '0 16px'
  }
}))

export const SubHeaderContainer = styledComponent(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutral[100],
  padding: '24px 0',
  borderBottom: `1px solid ${theme.palette.divider}`,
  div: {
    cursor: 'auto'
  },
  p: {
    cursor: 'auto !important'
  },
  [theme.breakpoints.down('xs')]: {
    padding: '12px 0'
  }
}))

export const SellersTitle = styledComponent(Typography)(({ theme }) => ({
  color: theme.palette.neutral[600],
  marginTop: '20px',
  fontWeight: 700,
  fontSize: '24px',
  lineHeight: '32px',
  marginBottom: '16px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '28px',
    lineHeight: '38px',
    marginTop: '16px',
    marginBottom: '16px'
  }
}))

export const StickyTopContainer = styledComponent(Box)(() => ({
  position: 'sticky',
  top: 0,
  zIndex: 999
}))

export const CenterSeeMoreSellersButton = styledComponent(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'left',
  marginTop: '24px',
  marginBottom: '24px',

  [theme.breakpoints.down('sm')]: {
    marginTop: '24px',
    marginBottom: '24px',
    justifyContent: 'center'
  }
}))

// Not sure how to handle theme here

type BoxProps = typeof Box.arguments
interface StyledBoxProps extends BoxProps {
  grow: boolean
}
export const GrowNoGrowBox = styledComponent(Box, {
  shouldForwardProp: (prop) => prop !== 'grow'
})<StyledBoxProps>(({ theme, grow }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
  paddingBottom: '20px',
  marginBottom: '15px',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '12px'
  },

  '&:last-child': {
    borderBottom: 'none'
  },

  ...(grow && {
    borderBottom: 'none',
    width: 'calc(100% + 24px)',
    marginLeft: '-12px',
    [theme.breakpoints.down('sm')]: { width: '100%', marginLeft: '0' }
  })
}))

export const ListContainer = styledComponent(Box)(({ theme }) => ({
  marginTop: '20px',

  [theme.breakpoints.down('sm')]: {
    marginTop: '12px'
  }
}))

export const SkeletonListContainer = styledComponent(Box)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }
}))

export const SkeletonContainer = styledComponent(Box)(() => ({
  marginBottom: '20px',
  marginTop: '20px',

  ':first-of-type': {
    marginTop: '0px'
  }
}))
